import { AppLayout } from '@/components/app-layout';
import { AppSumoCopilotGate } from '@/components/appsumo-copilot-gate.component';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { OnboardingCheck } from '@/components/onboarding-check.component';
import { SharedChatPage } from '@/containers/copilot/shared-chat-page.component';
import { createFileRoute } from '@tanstack/react-router';

// A Clu chat shared with the organization (clu_chat_sharing_v1). Not nested
// in /clu (the `_`), which renders no outlet. No flag guard here: links come
// only from the flag-gated Share menu, and the API reads the same key and
// 404s when it is off. A guard would also misread a link opened cold from
// Slack, since PostHog learns the org only after Clerk loads.
export const Route = createFileRoute('/clu_/shared/$conversationId')({
  component: SharedCluChatRoute,
});

function SharedCluChatRoute() {
  const { conversationId } = Route.useParams();
  return (
    <>
      <Head heading='Shared chat' />
      <AuthCheck>
        <OnboardingCheck>
          <AppLayout>
            <AppSumoCopilotGate>
              <SharedChatPage conversationId={conversationId} />
            </AppSumoCopilotGate>
          </AppLayout>
        </OnboardingCheck>
      </AuthCheck>
    </>
  );
}
